import styled from "@emotion/styled";

import {
  WaitingRoomHeader,
  WaitingRoomTabs,
  ErrorAlert,
  LoadingSpinner,
} from "@/components";
import { useSchedule } from "@/hooks/schedule/use-schedule";
import { useCustomTranslation } from "@/utils/useCustomTranslation";

interface WaitingRoomTemplateProps {
  scheduleId: number;
}

export const WaitingRoomTemplate = ({
  scheduleId,
}: WaitingRoomTemplateProps) => {
  const { t } = useCustomTranslation();
  const { data: schedule, isLoading, isError, error } = useSchedule(scheduleId);

  if (isLoading) {
    return <LoadingSpinner message={t("loading_schedule_information")} />;
  }

  if (isError || !schedule) {
    return <ErrorAlert error={error} />;
  }

  return (
    <Container>
      <WaitingRoomHeader schedule={schedule} />
      <WaitingRoomTabs schedule={schedule} />
    </Container>
  );
};

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;
